module.exports = {
	"16px_about": 61697,
	"16px_add": 61698,
	"16px_arrives": 61699,
	"16px_az": 61700,
	"16px_back": 61701,
	"16px_checkmark": 61702,
	"16px_chevronDown": 61703,
	"16px_chevronLeft_2px": 61704,
	"16px_chevronLeft": 61705,
	"16px_chevronRight_2px": 61706,
	"16px_chevronRight": 61707,
	"16px_chevronUp": 61708,
	"16px_circleArrowDown": 61709,
	"16px_circleArrowUp": 61710,
	"16px_close": 61711,
	"16px_delivery": 61712,
	"16px_disable": 61713,
	"16px_edit": 61714,
	"16px_forward": 61715,
	"16px_hamburger": 61716,
	"16px_hamburgerSmall": 61717,
	"16px_like": 61718,
	"16px_lock": 61719,
	"16px_noSync": 61720,
	"16px_notification_2": 61721,
	"16px_payment": 61722,
	"16px_radioButton": 61723,
	"16px_radioButtonBlue": 61724,
	"16px_radioButtonDot": 61725,
	"16px_return": 61726,
	"16px_sync": 61727,
	"16px_trash": 61728,
	"16px_user": 61729,
	"16px_visibility": 61730,
	"16px_visibilityActive": 61731,
	"24px_about": 61732,
	"24px_arrives": 61733,
	"24px_back": 61734,
	"24px_bag": 61735,
	"24px_Checkmark_circle_filled": 61736,
	"24px_Checkmark_circle_portal_filled": 61737,
	"24px_checkmark": 61738,
	"24px_chevromLeft": 61739,
	"24px_chevronDown": 61740,
	"24px_chevronLeft_2px": 61741,
	"24px_chevronLeft": 61742,
	"24px_chevronRight_2px": 61743,
	"24px_chevronRight": 61744,
	"24px_chevronUp": 61745,
	"24px_circleArrowDown": 61746,
	"24px_circleArrowUp": 61747,
	"24px_close": 61748,
	"24px_delivery": 61749,
	"24px_disable": 61750,
	"24px_discover": 61751,
	"24px_edit": 61752,
	"24px_filter": 61753,
	"24px_forward": 61754,
	"24px_hamburger": 61755,
	"24px_like": 61756,
	"24px_likeActive": 61757,
	"24px_noShipping": 61758,
	"24px_notification_1": 61759,
	"24px_notification_2": 61760,
	"24px_payment": 61761,
	"24px_radioButton": 61762,
	"24px_radioButtonBlue": 61763,
	"24px_radiobuttonDot": 61764,
	"24px_reset": 61765,
	"24px_return": 61766,
	"24px_search": 61767,
	"24px_shop": 61768,
	"24px_trash": 61769,
	"A1": 61770,
	"A2": 61771,
	"A3": 61772,
	"about": 61773,
	"arrives": 61774,
	"arrow_right_12px": 61775,
	"arrowUpRight": 61776,
	"bag": 61777,
	"C1": 61778,
	"delivery": 61779,
	"disabled": 61780,
	"discover": 61781,
	"E1": 61782,
	"E2": 61783,
	"edit": 61784,
	"expand": 61785,
	"Facebook_20x20": 61786,
	"filter": 61787,
	"icon_24px_Partnership": 61788,
	"illu_bag": 61789,
	"illu_flyingPackage": 61790,
	"illu_order": 61791,
	"illu_rotateScreen": 61792,
	"Instagram_20x20": 61793,
	"integrations": 61794,
	"J1": 61795,
	"K1": 61796,
	"L": 61797,
	"like": 61798,
	"Linkedin_20x20": 61799,
	"minus": 61800,
	"O1_noMargin": 61801,
	"O1": 61802,
	"order": 61803,
	"outOfStock": 61804,
	"P1": 61805,
	"pause": 61806,
	"payment": 61807,
	"play": 61808,
	"plus": 61809,
	"profile": 61810,
	"R1": 61811,
	"replay": 61812,
	"reset": 61813,
	"resize": 61814,
	"return": 61815,
	"search": 61816,
	"shop": 61817,
	"spotinLogoTM": 61818,
	"stripe-logo": 61819,
	"submenu": 61820,
	"symbol": 61821,
	"T": 61822,
	"T2": 61823,
	"tagImage": 61824,
	"tagSpot": 61825,
	"U1": 61826,
	"U2": 61827,
	"upload": 61828,
	"visibility": 61829,
	"visibilityActive": 61830,
	"visibilityWide": 61831,
	"Y": 61832
};


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/icons/icons.json
// module id = 153
// module chunks = 0